export const PAYMENT_DOCUMENT = "v1/post-documents-headers/payment";
export const UJE_PAYMENT_DOCUMENT = (communityId: string) => `v1/community/${communityId}/vendor-payment`;
export const PAYMENT_DOCUMENT_HEADERS = "v1/post-documents-headers";
export const COMMUNITY_API = "v1/community";
